import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'itemClassFix'
})
export class ItemClassFixPipe implements PipeTransform {

  static defaultHasValue(control: AbstractControl): boolean {
    return !!control.value;
  }

  transform(
    control: AbstractControl,
    hasValueCheck: boolean | ((arg0: AbstractControl) => boolean) = false
  ) {
    const result: any = {};
    if (control) {
      result['ng-untouched'] = control.untouched;
      result['ng-touched'] = control.touched;
      result['ng-pristine'] = control.pristine;
      result['ng-dirty'] = control.dirty;
      result['ng-valid'] = control.valid;
      result['ng-invalid'] = !control.valid;

      if (hasValueCheck) {
        const hasValue: boolean = (hasValueCheck === true
          ? ItemClassFixPipe.defaultHasValue
          : hasValueCheck)(control);
        result['input-has-value'] = hasValue;
        result['item-input-has-value'] = hasValue;
      }
    }

    return result;
  }

}
